import classNames from 'classnames';
import { TShelves } from 'utils/types';

type ShelfButtonProps = {
  code: string;
  shelvesByCode: Record<string, TShelves>;
  selectedCode?: string | null;
  onSelect: (code: string, shelf?: TShelves) => void;
  className?: string;
};

const ShelfButton = ({
  code,
  shelvesByCode,
  selectedCode,
  onSelect,
  className
}: ShelfButtonProps) => {
  const shelf = shelvesByCode[code.toUpperCase()];
  return (
    <button
      type="button"
      className={classNames('warehouse-shelf', className, {
        'is-selected': selectedCode?.toUpperCase() === code.toUpperCase(),
        'is-unmapped': !shelf
      })}
      onClick={() => onSelect(code, shelf)}
    >
      {code}
    </button>
  );
};

export default ShelfButton;
